import { type SelectChangeEvent, styled } from '@mui/material';
import type { FieldConfigurationDto } from '@tempo-io/fim3-dto';
import { MultiSelect } from '../MultiSelect';

export const StyledMultiSelect = styled(MultiSelect, {
  shouldForwardProp: (prop) => prop !== 'isEditableText',
})<{ isEditableText?: boolean }>(({ theme, isEditableText }) =>
  isEditableText
    ? {
        display: 'flex',
        alignItems: 'center',
        '.MuiInputBase-root': {
          marginLeft: theme.spacing(-2),
          paddingLeft: theme.spacing(0.5),
          width: '100%',
        },
        '.MuiInputBase-input': {
          paddingLeft: theme.spacing(0.5),
        },
        '& fieldset': {
          opacity: 0,
        },
        '&:hover fieldset': {
          opacity: 1,
        },
        '& .MuiSvgIcon-root': {
          opacity: 0,
        },
        '&:hover .MuiSvgIcon-root': {
          opacity: 1,
        },
        '.Mui-focused ': {
          ' & .MuiOutlinedInput-notchedOutline': {
            opacity: 1,
          },
        },
      }
    : {},
);

export const MultiSelectFieldInput = ({
  fieldConfiguration,
  values,
  setValues,
  isEditableText,
  disabled,
}: {
  fieldConfiguration: FieldConfigurationDto;
  disabled?: boolean;
  values: string[];
  setValues: (values: string[]) => void;
  isEditableText?: boolean;
  autoFocus?: boolean;
}) => {
  if (fieldConfiguration.fieldType !== 'LIST') return;

  const onSelectChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value as string[];
    setValues(value);
  };

  return (
    <StyledMultiSelect
      {...{
        className: 'fs-exclude',
        'data-dd-action-name': 'FIM 3 Custom Field - multi-select redacted',
        'data-testid': 'fim3-multi-select-input',
        value: values.filter(Boolean),
        onChange: onSelectChange,
        placeholder: isEditableText ? undefined : 'Choose a value',
        size: 'small',
        menuItems: fieldConfiguration.options.map((option) => ({
          value: option,
          label: option,
        })),
        disabled: disabled,
        isOptionSelected: (value: string | number) => values.includes(String(value)),
      }}
    />
  );
};
